﻿$(function () {
    $('.datepicker-maiturimix-finnish-format').datepicker({
        dateFormat: 'dd/mm/yy',
        firstDay: 1,
        monthNames: ["Tammikuu", "Helmikuu", "Maaliskuu", "Huhtikuu", "Toukokuu", "Kesäkuu", "Heinäkuu", "Elokuu", "Syyskuu", "Lokakuu", "Marraskuu", "Joulukuu"],
        dayNamesMin: ['So', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La'],
    });

    $('#showNewFeeds').click(function () {
        $('#feedList').show();
        $('#feedDetails').hide();
        $('#editFeed').hide();
        $('#mixedDetails').hide();
        $('#newFeeds').show();
        $('#recentMixes').hide();
        $(this).addClass('active-tab');
        $('#showMyMixes').removeClass('active-tab');
        $('#btnAddLeftOver').hide();
        $('#feedmixing').hide();
        $('#leftOverDiv').hide();
    });

    $('#showMyMixes').click(function () {
        $('#feedList').show();
        $('#feedDetails').hide();
        $('#editFeed').hide();
        $('#mixedDetails').hide();
        $('#recentMixes').show();
        $('#newFeeds').hide();
        $(this).addClass('active-tab');
        $('#showNewFeeds').removeClass('active-tab');
        $('#feedmixing').hide();
        $('#leftOverDiv').hide();
    });

    function calculateDailyIntake() {
        if (!isNaN(parseInt($('#txtNumberOfAnimals').val())) && parseInt($('#txtNumberOfAnimals').val()) > 0) {
            let animalCount = parseInt($('#txtNumberOfAnimals').val());
            let batchSize = parseInt($('#feedSize').val());
            let dailyIntake = (batchSize / animalCount).toFixed(1);
            $('#spDailyIntake').text(dailyIntake);
        }
        else {
            $('#spDailyIntake').text('');
        }
    }

    $('.newRecipe').click(function () {
        $.ajax({
            type: 'GET',
            url: '/api/maiturimix/feeds/' + $(this).attr('id'),
            dataType: 'json',
            contentType: 'application/json',
            success: function (data) {
                $('#feedPlanName').text(data.MixName);
                $('#spfeedSize').text(data.Size);
                $('#hdnActualFeedSize').val(data.ActualFeedSize);
                $('#feedSize').val(data.Size);
                $('#txtFeedPercent').val(Math.round(data.FeedPercent));
                $('#txtNumberOfAnimals').val(data.AnimalCount > 0 ? data.AnimalCount : '');
                $('#chkAutoScale').attr('checked', data.ScaleAccordingToFirstItem);
                bindRecipe(data);
                calculateDailyIntake();
                $('#feedList').hide();
                $('#feedDetails').show();
                $('#editFeed').hide();
                $('#mixedDetails').hide();
            },
            error: function (data) {
                console.log(data.responseText);
            }
        });

    });

    function bindRecipe(data, editingTableOnly = false) {
        let items = '<table id=\'ingrediantstable\'>';
        items += '<thead>';
        items += '<tr>';
        items += '<th>Komponentti</th><th>Määrä (kg)</th>';
        items += '</tr>';
        items += '</thead>';
        items += '<tbody>';

        let editingItems = '<table id=\'editingingrediantstable\'>';
        editingItems += '<thead>';
        editingItems += '<tr>';
        editingItems += '<th>Komponentti</th><th>Alkuperäinen kuiva-aine (g/kg)</th><th>Uusi kuiva-aine (g/kg)</th><th>Määrä (kg)</th>';
        editingItems += '</tr>';
        editingItems += '</thead>';
        editingItems += '<tbody>';

        for (let i = 0; i < data.Feeds.length; i++) {
            items += '<tr id=\'' + i + '\'>';
            items += '<td>' + data.Feeds[i].FeedName + '</td>';
            items += '<td><span class=\'fixed\' style=\'display:none;\'>' + Math.round(data.Feeds[i].PlannedWeight) + '</span><span class=\'floating\'>' +
                Math.round(data.Feeds[i].PlannedWeight) + '</span></td>';
            items += '</tr>';

            editingItems += '<tr>';
            editingItems += '<td><input type=\'hidden\' value=\'' + data.Feeds[i].FeedId + '\'/>' +
                data.Feeds[i].FeedName + '</td>';
            editingItems += '<td><input type=\'number\' class=\'tinyInput\' value=\'' +
                data.Feeds[i].Nutritions.OriginalDryMatter + '\' inputmode=\'decimal\' disabled/></td>';

            editingItems += '<td><span style=\'display:none;\'>' + data.Feeds[i].Nutritions.DryMatter + '</span><input type=\'number\' class=\'tinyInput dryMatter\' value=\'' +
                data.Feeds[i].Nutritions.DryMatter + '\' inputmode=\'decimal\'/></td>';
            editingItems += '<td><span class=\'fixed\' style=\'display:none;\'>' + Math.round(data.Feeds[i].PlannedWeight) + '</span><input type=\'number\' id=\'txt' + i +
                '\' class=\'tinyInput feedItem\' value=\'' + Math.round(data.Feeds[i].PlannedWeight) + '\' inputmode=\'decimal\' disabled/>';
            editingItems += data.Feeds[i].AdditionalItem ? '<a  id=\'' + data.Feeds[i].FeedId + '\' class=\'lm__link remove\'><span class="glyphicon glyphicon-trash"></span></a></td>' :
                '</td > ';
            editingItems += '</tr>'

        }

        items += '</tbody>';
        editingItems += '</tbody>';
        items += '</table>';
        editingItems += '</table>';

        if (!editingTableOnly) {
            $('#feedItemsList').html(items);
            $('#mixingItemsList').html(items);
        }

        $('#editingFeedItems').html(editingItems);
    }

    $(document).on('input', '.feedItem', function () {

        let newval = $(this).val();
        if (newval != '' && newval != 0) {

            let temp = 0;
            $('#editingingrediantstable > tbody > tr').each(function () {

                let feedWeightInput = $(this).find('td:last input').val();
                if (feedWeightInput != '' && feedWeightInput != 0) {
                    temp += parseInt(feedWeightInput);
                }
            });
            $('#spfeedSize').text(temp);
        }
    });

    $('#aSaveFeed').click(function () {
        let obj = {}
        let feeds = [];
        obj.Size = $('#spfeedSize').text();

        if ($('#chkAutoScale').is(':checked')) {
            obj.scaleAccordingToFirstItem = true;
        }
        else {
            obj.scaleAccordingToFirstItem = false;
        }

        $('#editingingrediantstable > tbody > tr').each(function (i) {
            let feed = {};
            feed.Feedid = $(this).find('td:first input').val();
            feed.FeedName = $(this).find('td:first').text();
            feed.Nutritions = {};
            feed.Nutritions.DryMatter = $(this).find('td:eq(2) input').val();
            feed.PlannedWeight = $(this).find('td:last input').val();
            feed.SortOrder = i;
            feeds.push(feed);
        });

        obj.Feeds = feeds;

        $.ajax({
            type: 'POST',
            url: '/api/maiturimix/updatefeed',
            dataType: 'json',
            data: JSON.stringify(obj),
            contentType: 'application/json',
            success: function (data) {
                $('#feedSize').val(data.Size);
                bindRecipe(data);
                calculateDailyIntake();
                $('#feedList').hide();
                $('#feedDetails').show();
                $('#editFeed').hide();
                $('#feedmixing').hide();
                $('#mixedDetails').hide();
            },
            error: function (data) {
                console.log(data.responseText);
            }
        });
    });

    $(document).on('input', '.dryMatter', function () {

        if ($(this).val() != '') {
            let tr = $(this).closest('tr');
            let originalDyrMatter = parseInt($(tr).find('td:eq(2) span').text());
            let originalWeight = parseInt($(tr).find('td:last span').text());
            let newWeight = Math.round((originalDyrMatter * originalWeight) / $(this).val());
            $(tr).find('td:last input').val(newWeight);

            let temp = 0;

            $('#editingingrediantstable > tbody > tr').each(function () {
                let feedWeightInput = $(this).find('td:last input').val();
                if (feedWeightInput != '' && feedWeightInput != 0) {
                    temp += parseInt(feedWeightInput);
                }
            });
            $('#spfeedSize').text(temp);
        }
    });

    $(document).on('input', '#txtNumberOfAnimals', function () {
        calculateDailyIntake();
    });

    $('#finishMixing').click(function () {
        let recipeComment = $('#txtRecipeComment').val();
        $.ajax({
            type: 'POST',
            url: '/api/maiturimix/savemix?recipeComment=' + recipeComment,
            dataType: 'json',
            contentType: 'application/json',
            success: function (returnData) {

                if (returnData.RecordId > 0) {
                    let items = '<table id=\'finalIngrediantsTable\'>';
                    let actualTotalWeight = 0;

                    for (let i = 0; i < returnData.data.CustomerMixFeeds.length; i++) {
                        items += '<tr>';
                        items += '<td>' + returnData.data.CustomerMixFeeds[i].FeedName + '</td>';
                        items += '<td>' + returnData.data.CustomerMixFeeds[i].ActualWeight + '/' + returnData.data.CustomerMixFeeds[i].PlannedWeight + '</td>';
                        items += '<td>' + returnData.data.CustomerMixFeeds[i].FeedComment + '</td>';
                        items += '</tr>';
                        actualTotalWeight += parseInt(returnData.data.CustomerMixFeeds[i].ActualWeight);
                    }

                    items += '</table>';
                    $('#MixedweightRatio').text(actualTotalWeight + '/' + returnData.data.OriginalWeight);
                    $('#mixedFeedGuideline').text(returnData.data.Guideline);
                    $('#mixedFeedAnimalCount').text(returnData.data.AnimalCount);
                    $('#mixedComment').text(returnData.data.MixComment);
                    $('#mixedItemsList').html(items);
                    var createdOn = returnData.data.CreatedOn;
                    var date = new Date(createdOn);
                    var options = { timeZone: 'Europe/Helsinki' };
                    var createdDate = date.toLocaleDateString('fi-FI', options);
                    var createdTime = date.toLocaleTimeString('fi-FI', {
                        hour: '2-digit',
                        minute: '2-digit',
                        timeZone: 'Europe/Helsinki',
                        hour12: true
                    });
                    $('#mixedFeedDate').text(createdDate);
                    $('#mixedFeedTime').text(createdTime);
                    $('#feedList').hide();
                    $('#feedDetails').hide();
                    $('#editFeed').hide();
                    $('#feedmixing').hide();
                    $('#mixedDetails').show();
                    $('#txtMixId').val(returnData.RecordId);
                }
                else {
                    alert('something went wrong, please try again!');
                }
            }
        });
    });

    $('.mixedFeed').click(function (e) {
        let id = $(this).attr('id');
        $.ajax({
            type: 'GET',
            url: '/api/maiturimix/getmixedfeedbyid?id=' + id,
            dataType: 'json',
            contentType: 'application/json',
            success: function (returnData) {

                let items = '<table id=\'finalIngrediantsTable\'>'
                items += '<thead>';
                items += '<tr>';
                items += '<th>Komponentti</th><th><span class=\'padding-left-30\'> Määrä (kg)</span><br/>Toteutunut / Suunniteltu</th><th>Kommentit</th>';
                items += '</tr>';
                items += '</thead>';
                items += '<tbody>';
                let actualTotalWeight = 0;

                for (let i = 0; i < returnData.CustomerMixFeeds.length; i++) {
                    items += '<tr>';
                    items += '<td>' + returnData.CustomerMixFeeds[i].FeedName + '</td>';
                    items += '<td>' + returnData.CustomerMixFeeds[i].ActualWeight + '/' + returnData.CustomerMixFeeds[i].PlannedWeight + '</td>';
                    items += '<td>' + returnData.CustomerMixFeeds[i].FeedComment + '</td>';
                    items += '</tr>';
                    actualTotalWeight += parseInt(returnData.CustomerMixFeeds[i].ActualWeight);
                }

                items += '<tbody>';
                items += '</table>';
                $('#MixedweightRatio').text(actualTotalWeight + '/' + returnData.OriginalWeight);
                $('#mixedFeedGuideline').text(returnData.Guideline);
                $('#mixedFeedAnimalCount').text(returnData.AnimalCount);
                $('#mixedComment').text(returnData.MixComment);
                $('#mixedItemsList').html(items);
                $('#txtMixId').val(id);
                var createdOn = returnData.CreatedOn;
                var date = new Date(createdOn);
                var month = date.getMonth() + 1;
                var createdDate = date.getDate() + '.' + month + '.' + date.getFullYear();
                var minutes = date.getMinutes();
                var minutesString = minutes < 10 ? '0' + minutes : minutes;
                var createdTime = date.getHours() + ':' + minutesString;
                $('#mixedFeedDate').text(createdDate);
                $('#mixedFeedTime').text(createdTime);

                if (parseInt(returnData.LeftOvers) > 0) {
                    $('#leftOverDiv').css("display", "inline");
                    $('#spLeftOver').text(returnData.LeftOvers);
                    $('#txtLeftOver').val(returnData.LeftOvers);
                }

                $('#feedList').hide();
                $('#feedDetails').hide();
                $('#editFeed').hide();
                $('#feedmixing').hide();
                $('#mixedDetails').show();
                $('#btnAddLeftOver').show();

            }
        });
    });

    $('#feedSize').change(function () {
        let originalSize = parseInt($('#hdnActualFeedSize').val());
        let newSize = parseInt($(this).val());
        let percent = (newSize * 100) / originalSize;
        $('#txtFeedPercent').val(Math.round(percent));
        $('#spfeedSize').text(newSize);

        let obj = {}
        let feeds = [];

        $('#editingingrediantstable > tbody > tr').each(function () {
            let feed = {};
            feed.Feedid = $(this).find('td:first input').val();
            feed.Nutritions = {};
            feed.Nutritions.DryMatter = $(this).find('td:eq(2) input').val();
            feed.PlannedWeight = $(this).find('td:last input').val();
            feeds.push(feed);
        });

        obj.Feeds = feeds;
        obj.Size = parseInt($(this).val());

        if ($('#chkAutoScale').is(':checked')) {
            obj.ScaleAccordingToFirstItem = true;
        }

        $.ajax({
            type: 'POST',
            url: '/api/maiturimix/updatefeed',
            dataType: 'json',
            data: JSON.stringify(obj),
            contentType: 'application/json',
            success: function (data) {
                bindRecipe(data);
            }
        });
        calculateDailyIntake();
    });

    $(document).on('input', '#txtFeedPercent', (function () {
        let originalSize = $('#hdnActualFeedSize').val();
        let newSize = originalSize;

        if ($(this).val() == '' || $(this).val() === 0) {
            newSize = originalSize;
        }
        else {
            newSize = Math.round(((originalSize * $(this).val()) / 100));
        }

        $('#feedSize').val(newSize);
        $('#spfeedSize').text(newSize);

        let obj = {}
        let feeds = [];

        $('#editingingrediantstable > tbody > tr').each(function () {
            let feed = {};
            feed.Feedid = $(this).find('td:first input').val();
            feed.Nutritions = {};
            feed.Nutritions.DryMatter = $(this).find('td:eq(2) input').val();
            feed.PlannedWeight = $(this).find('td:last input').val();
            feeds.push(feed);
        });

        obj.Feeds = feeds;
        obj.Size = parseInt($('#feedSize').val());

        if ($('#chkAutoScale').is(':checked')) {
            obj.ScaleAccordingToFirstItem = true;
        }

        calculateDailyIntake();

        $.ajax({
            type: 'POST',
            url: '/api/maiturimix/updatefeed',
            dataType: 'json',
            data: JSON.stringify(obj),
            contentType: 'application/json',
            success: function (data) {
                bindRecipe(data);
            }
        });

    }));

    $('#gotolist').click(function () {
        window.location.href = window.location.href.replace('#', '');
    });

    $('#addMix').click(function () {
        let feedName = $('#currentMixingFeed').text();
        let expectedSize = parseInt($('#currentMixingExpectedNumber').text());
        let enteredFeedSize = parseInt($('#txtActualNumber').val());
        let feedActualWeight = parseInt($('#hdnFeedActualWeight').text());
        let feedComment = $('#txtFeedComment').val();
        let scaleaccordingcomponentsBtn = false;
        if ($('#btncalculatethefinalrecipe').is(':disabled')) {
            scaleaccordingcomponentsBtn = true;
        }
        if (expectedSize > enteredFeedSize) {
            let diff = expectedSize - enteredFeedSize;
            feedActualWeight = feedActualWeight - diff;
        }
        else if (expectedSize < enteredFeedSize) {
            let diff = enteredFeedSize - expectedSize;
            feedActualWeight = feedActualWeight + diff;
        }
        let sortOrder = 0;
        $('#mixingItemsList >tbody > tr.mix-updated').each(function (i, e) {
            sortOrder++;
        });

        sortOrder = sortOrder + 1;

        $.ajax({
            type: 'GET',
            url: '/api/maiturimix/updatemix?feedName=' + feedName + "&weight=" + feedActualWeight + "&sortOrder=" + sortOrder + "&scaleaccordingcomponentsBtn=" + scaleaccordingcomponentsBtn + "&feedComment=" + feedComment,
            dataType: 'json',
            contentType: 'application/json',
            success: function (data) {
                $('#txtFeedComment').val('');
                bindMixingTable(data);

                if ($('#mixingItemsList > tbody > tr').length == $('#mixingItemsList > tbody > tr.mix-updated').length) {
                    $('#finishMixing').click();
                }
                else {
                    selectRowForMix();
                }
            }
        });
    });

    function selectRowForMix() {
        let expectedMix = 0;
        $('#mixingItemsList >tbody > tr.mix-updated').each(function (i, e) {
            expectedMix += parseInt($(this).find('td:eq(1) span.actual').text());
            $(this).find('td:eq(1) span.actual').show();
            $(this).find('td:eq(1) span.planned').hide();
        });
        $('#mixingItemsList >tbody > tr').each(function (i, e) {
            if (!$(this).hasClass('mix-updated')) {
                expectedMix += parseInt($(this).find('td:eq(1) span.planned').text());
                $(this).find('td:eq(1)').html();
                $(this).addClass('current-mixing-item');
                $('#currentMixingFeed').text($(this).find('td:first').html());
                $('#hdnFeedActualWeight').text($(this).find('td:eq(1) span.planned').text());
                $('#feedActualWeight').text($(this).find('td:eq(1) span.planned').text() + " Kg");
                $('#currentMixingExpectedNumber').text(expectedMix);
                $('#txtActualNumber').val(expectedMix);
                return false;
            }
        });
    }

    $('#aEditFeed').click(function () {

        $.ajax({
            type: 'GET',
            url: '/api/maiturimix/rebindfeedforedit',
            dataType: 'json',
            contentType: 'application/json',
            success: function (data) {
                bindRecipe(data);
                $('#feedList').hide();
                $('#feedDetails').hide();
                $('#editFeed').show();
                $('#feedmixing').hide();
            }
        });
    });

    $('.back').click(function () {
        $('#feedList').hide();
        $('#feedDetails').show();
        $('#editFeed').hide();
        $('#feedmixing').hide();
        $('#mixedDetails').hide();
    });

    $('#btnStartMixing').click(function () {

        let obj = {}
        let feeds = [];
        if ($('#txtNumberOfAnimals').val() == "" || $('#txtNumberOfAnimals').val() == "0") {
            $('#animalCountError').css("display", "inline");
            return;
        }
        else {
            $('#animalCountError').css("display", "none");
        }
        obj.Size = parseInt($('#feedSize').val());

        if ($('#chkAutoScale').is(':checked')) {
            obj.scaleAccordingToFirstItem = true;
            $('#btncalculatethefinalrecipe').removeAttr('disabled');
        }
        else {
            obj.scaleAccordingToFirstItem = false;
            $('#btncalculatethefinalrecipe').hide();
        }

        $('#editingingrediantstable > tbody > tr').each(function () {
            let feed = {};
            feed.Feedid = $(this).find('td:first input').val();
            feed.Nutritions = {};
            feed.Nutritions.DryMatter = $(this).find('td:eq(2) input').val();
            feed.PlannedWeight = $(this).find('td:last input').val();
            feeds.push(feed);
        });

        obj.Feeds = feeds;

        $.ajax({
            type: 'POST',
            url: '/api/maiturimix/updatefeed',
            dataType: 'json',
            data: JSON.stringify(obj),
            contentType: 'application/json',
            success: function (data) {
            }
        });

        $.ajax({
            type: 'GET',
            url: '/api/maiturimix/getfeedformix?animalCount=' + $('#txtNumberOfAnimals').val(),
            dataType: 'json',
            contentType: 'application/json',
            success: function (data) {

                $('#weightRatio').text('0/' + data.Size);
                bindMixingTable(data);

                selectRowForMix();
            }
        });

        $('#feedList').hide();
        $('#feedDetails').hide();
        $('#editFeed').hide();
        $('#feedmixing').show();
        $('#mixedDetails').hide();

    });

    function bindMixingTable(data) {
        let items = '';
        let actualtotalWeight = 0;

        items += '<thead>';
        items += '<tr>';
        items += '<th>Komponentti</th><th>Määrä (kg)</th>';
        items += '<th style="display: none;">Alkuperäinen Järjestys</th>'; // Hidden original sort order
        items += '<th style="display: none;">Nykyinen Järjestys</th>'; // Hidden current sort order
        items += '</tr>';
        items += '</thead>';
        items += '<tbody>';

        for (let i = 0; i < data.Feeds.length; i++) {

            if (data.Feeds[i].MixUpdated) {
                items += '<tr class=\'mix-updated\'>';
            }
            else {
                items += '<tr class="selectComponentForMix current-mixing-item">';
            }

            items += '<td>' + data.Feeds[i].FeedName + '</td>';
            items += '<td><span class=\'actual\' style=\'display:none;\'>' + (data.Feeds[i].MixUpdated ? Math.round(data.Feeds[i].ActualWeight) : 0) +
                '</span><span class=\'planned\'>' + Math.round(data.Feeds[i].PlannedWeight) + '</span></td>';

            // Hidden columns for original and current sort orders
            items += '<td style="display: none;">' + data.Feeds[i].ActualSortOrder + '</td>'; // Original sort order
            items += '<td style="display: none;">' + data.Feeds[i].SortOrder + '</td>'; // Current sort order
            items += '</tr>';

            if (data.Feeds[i].MixUpdated) {
                actualtotalWeight += Math.round(data.Feeds[i].ActualWeight);
            }
        }

        items += '</tbody>';
        $('#weightRatio').text(actualtotalWeight + '/' + data.Size);
        $('#mixingItemsList').html('').append(items);
    }

    $('#btnAddAddtionalItem').click(function () {
        $('#preview').modal('show');
        $("#preview").fadeIn();

    });

    $('#btnAddLeftOver').click(function () {
        $('#leftoverpopup').modal('show');
        $("#leftoverpopup").fadeIn();
        $('#spleftovererror').css('display', 'none');

    });

    $('#btnAddManualMix').click(function () {
        $('#manualmix').modal('show');
        $("#manualmix").fadeIn();
        $('#spmanualmixError').css('display', 'none');
        $('#ddlRecipes').val('');
        $('#txtmanualmixBatchSize').val('');
        $('#txtmanualmixAnimalCount').val('');
        $('#manualMixDate').val('');

    });

    $('#ddlRecipes').change(function () {

        if ($(this).val() != '') {
            $.ajax({
                type: 'GET',
                url: '/api/maiturimix/feeds/' + $(this).val(),
                dataType: 'json',
                contentType: 'application/json',
                success: function (data) {

                    $('#txtmanualmixBatchSize').val(data.Size);
                    $('#txtmanualmixAnimalCount').val(data.AnimalCount > 0 ? data.AnimalCount : '');
                },
                error: function (data) {
                    console.log(data.responseText);
                }
            });
        }
        else {
            $('#txtmanualmixBatchSize').val('');
            $('#txtmanualmixAnimalCount').val('');
        }
    });

    $('#btnSaveManualMix').click(function () {
        $('#spmanualmixError').css('display', 'none;');

        if ($('#ddlRecipes').val() == '' || $('#txtmanualmixBatchSize').val() == '' || $('#manualMixDate').val() == '' || $('#txtmanualmixAnimalCount').val() == '') {
            $('#spmanualmixError').css('display', 'inline');
        }
        else {
            let obj = {}
            obj.FeedingPlanId = $('#ddlRecipes').val();
            obj.Size = $('#txtmanualmixBatchSize').val();
            let dateParts = $('#manualMixDate').val().split('/');
            obj.StartDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`; // Format as YYYY-MM-DD
            obj.AnimalCount = $('#txtmanualmixAnimalCount').val();

            $.ajax({
                type: 'POST',
                url: '/api/maiturimix/createmanualmix',
                dataType: 'json',
                data: JSON.stringify(obj),
                contentType: 'application/json',
                success: function (data) {
                    window.location.href = window.location.href;
                }
            });
        }
    });

    $('#btnSaveLeftOver').click(function () {
        $('#spleftovererror').css('display', 'none');
        let leftOver = $('#txtLeftOver').val();
        let mixId = $('#txtMixId').val();
        if (leftOver == '') {
            $('#spleftovererror').css('display', 'inline');
        }
        else {

            $.ajax({
                type: 'GET',
                url: '/api/maiturimix/addleftover?id=' + mixId + '&leftover=' + leftOver,
                dataType: 'json',
                contentType: 'application/json',
                success: function (response) {
                    if (response.Status == 'OK') {
                        $('#leftoverpopup').modal('hide');
                        $("#leftoverpopup").fadeOut();
                        $('#spLeftOver').text(leftOver);
                        $('#leftOverDiv').css("display", "inline");
                    }
                    else {

                    }
                }
            });
        }
    });

    $('#btnReCalculate').click(function () {

        if (confirm('Oletko varma? Kaikki tekemäsi muutokset menetetään.')) {
            if ($('#txtNumberOfAnimals').val() != '') {
                $.ajax({
                    type: 'POST',
                    url: '/api/maiturimix/recalculate?customerAnimalCount=' + $('#txtNumberOfAnimals').val(),
                    dataType: 'json',
                    contentType: 'application/json',
                    success: function (data) {
                        $('#spfeedSize').text(data.Size);
                        $('#hdnActualFeedSize').val(data.Size);
                        $('#feedSize').val(data.Size);
                        $('#txtNumberOfAnimals').val(data.AnimalCount > 0 ? data.AnimalCount : '');
                        bindRecipe(data);
                        calculateDailyIntake();
                    }
                });
            }
        }
    });

    $(document).on('click', '.remove', function () {
        let feedId = $(this).attr('id');
        let obj = {}
        let feeds = [];

        $('#editingingrediantstable > tbody > tr').each(function (i) {
            let feed = {};
            feed.Feedid = $(this).find('td:first input').val();
            feed.FeedName = $(this).find('td:first').text();
            feed.Nutritions = {};
            feed.Nutritions.DryMatter = $(this).find('td:eq(2) input').val();
            feed.PlannedWeight = $(this).find('td:last input').val();
            feed.SortOrder = i;
            feeds.push(feed);
        });
        obj.Feeds = feeds;

        let newItem = {};
        newItem.FeedId = feedId;
        var postedData = { Recipe: obj, ItemToAdd: newItem };

        $.ajax({
            type: 'POST',
            url: '/api/maiturimix/removeitem',
            dataType: 'json',
            data: JSON.stringify(postedData),
            contentType: 'application/json',
            success: function (response) {
                if (response.Status == 'OK') {
                    bindRecipe(response.Data, true);
                    $('#spfeedSize').text(response.Data.Size);
                }
            }
        });
    });

    $('#AddItem').click(function () {
        $('#modalerror').text('');
        let item = $('#ddlAdditionalItems').val();
        let size = $('#txtAdditonalItemSize').val();

        if (item == '' || size == '') {
            $('#modalerror').text($('#emtyitemerror').text());
            return;
        }

        let obj = {}
        let feeds = [];

        $('#editingingrediantstable > tbody > tr').each(function (i) {
            let feed = {};
            feed.Feedid = $(this).find('td:first input').val();
            feed.FeedName = $(this).find('td:first').text();
            feed.Nutritions = {};
            feed.Nutritions.DryMatter = $(this).find('td:eq(2) input').val();
            feed.PlannedWeight = $(this).find('td:last input').val();
            feed.SortOrder = i;
            feed.AdditionalItem = $(this).find('.remove').length > 0;
            feeds.push(feed);
        });
        obj.Feeds = feeds;

        let newItem = {};
        newItem.FeedName = item;
        newItem.PlannedWeight = size;
        newItem.ActualWeight = size;
        var postedData = { Recipe: obj, ItemToAdd: newItem };
        $.ajax({
            type: 'POST',
            url: '/api/maiturimix/additem',
            dataType: 'json',
            data: JSON.stringify(postedData),
            contentType: 'application/json',
            success: function (response) {
                if (response.Status == 'OK') {
                    bindRecipe(response.Data, true);
                    $('#spfeedSize').text(response.Data.Size);
                    $('#preview').modal('hide');
                    $("#preview").fadeOut();
                }
                else if (response.Status == 'Duplicate') {
                    $('#modalerror').text($('#duplicateitemerror').text());
                }
                else {
                }

            }
        });

    });

    // third party plugin code to add + - buttons
    $.fn.niceNumber = function (options) {
        var defaults = {
            autoSize: false,
            autoSizeBuffer: 1,
            buttonDecrement: '-',
            buttonIncrement: '+',
            buttonPosition: 'around',
            increamentValue: 10,

            /**
                callbackFunction
                @param {$input} currentInput - the input running the callback
                @param {number} amount - the amount after increase/decrease
                @param {object} settings - the passed niceNumber settings
            **/
            onDecrement: false,
            onIncrement: false,
        };
        var settings = $.extend(defaults, options);

        return this.each(function () {
            var currentInput = this,
                $currentInput = $(currentInput),
                maxValue = $currentInput.attr('max'),
                minValue = $currentInput.attr('min'),
                attrMax = null,
                attrMin = null;

            // Skip already initialized input
            if ($currentInput.attr('data-nice-number-initialized')) return;

            // Handle max and min values
            if (
                maxValue !== undefined &&
                maxValue !== false
            ) {
                attrMax = parseFloat(maxValue);
            }

            if (
                minValue !== undefined &&
                minValue !== false
            ) {
                attrMin = parseFloat(minValue);
            }

            // Fix issue with initial value being < min
            if (attrMin && !currentInput.value) {
                $currentInput.val(attrMin);
            }

            // Generate container
            var $inputContainer = $('<div/>', {
                class: 'nice-number',
            }).insertAfter(currentInput);

            // Generate interval (object so it is passed by reference)
            var interval = {};

            // Generate buttons
            var $minusButton = $('<button/>')
                .attr('type', 'button')
                .attr('class', 'lm__primary-btn')
                .html(settings.buttonDecrement)
                .on('mousedown mouseup mouseleave', function (event) {
                    changeInterval(event.type, interval, function () {
                        var currentValue = parseFloat($currentInput.val() || 0);
                        if (
                            attrMin == null ||
                            attrMin < currentValue
                        ) {
                            var newValue = currentValue - settings.increamentValue;
                            $currentInput.val(newValue).change();
                            if (settings.onDecrement) {
                                settings.onDecrement(
                                    $currentInput,
                                    newValue,
                                    settings
                                );
                            }
                        }
                    });

                    // Trigger the input event here to avoid event spam
                    if (event.type == 'mouseup' || event.type == 'mouseleave') {
                        $currentInput.trigger('input');
                    }
                });

            var $plusButton = $('<button/>')
                .attr('type', 'button')
                .attr('class', 'lm__primary-btn')
                .html(settings.buttonIncrement)
                .on('mousedown mouseup mouseleave', function (event) {
                    changeInterval(event.type, interval, function () {
                        var currentValue = parseFloat($currentInput.val() || 0);
                        if (
                            attrMax == null ||
                            attrMax > currentValue
                        ) {
                            var newValue = currentValue + settings.increamentValue;
                            $currentInput.val(newValue).change();
                            if (settings.onIncrement) {
                                settings.onIncrement(
                                    $currentInput,
                                    newValue,
                                    settings
                                );
                            }
                        }
                    });

                    // Trigger the input event here to avoid event spam
                    if (event.type == 'mouseup' || event.type == 'mouseleave') {
                        $currentInput.trigger('input');
                    }
                });

            // Remember that we have initialized this input
            $currentInput.attr('data-nice-number-initialized', true);

            // Append elements
            switch (settings.buttonPosition) {
                case 'left':
                    $minusButton.appendTo($inputContainer);
                    $plusButton.appendTo($inputContainer);
                    $currentInput.appendTo($inputContainer);
                    break;
                case 'right':
                    $currentInput.appendTo($inputContainer);
                    $minusButton.appendTo($inputContainer);
                    $plusButton.appendTo($inputContainer);
                    break;
                case 'around':
                default:
                    $minusButton.appendTo($inputContainer);
                    $currentInput.appendTo($inputContainer);
                    $plusButton.appendTo($inputContainer);
                    break;
            }

            // Nicely size input
            if (settings.autoSize) {
                $currentInput.width(
                    $currentInput.val().length + settings.autoSizeBuffer + 'ch'
                );
                $currentInput.on('keyup input', function () {
                    $currentInput.animate(
                        {
                            width:
                                $currentInput.val().length +
                                settings.autoSizeBuffer +
                                'ch'
                        },
                        200
                    );
                });
            }
        });
    };

    function changeInterval(eventType, interval, callback) {
        if (eventType == 'mousedown') {
            interval.timeout = setTimeout(function () {
                interval.actualInterval = setInterval(function () {
                    callback();
                }, 100);
            }, 200);
            callback();
        } else {
            if (interval.timeout) {
                clearTimeout(interval.timeout);
            }
            if (interval.actualInterval) {
                clearInterval(interval.actualInterval);
            }
        }
    }

    $('.number').niceNumber();
    $('#txtActualNumber').niceNumber({ increamentValue: 5 });

    $('#btnconfirmDeleteManualMix').click(function () {
        $('#deletemanualmixerror').css('display', 'none');
        let mixId = $('#hdnIdToDelete').val();
        if (mixId == '') {
            $('#deletemanualmixerror').css('display', 'inline');
        }
        else {
            $.ajax({
                type: 'GET',
                url: '/api/maiturimix/deletemix?id=' + mixId,
                dataType: 'json',
                contentType: 'application/json',
                success: function (response) {
                    if (response.Status == 'OK') {
                        $('#deletemanualmixpopup').modal('hide');
                        $("#deletemanualmixpopup").fadeOut();
                        window.location.reload();
                    }
                    else {
                        alert($('#hdnDeleteErrorMsg').val());
                    }
                }
            });
        }
    });

    $('#btncancelDeleteManualMix').click(function () {
        $('#deletemanualmixpopup').modal('hide');
        $("#deletemanualmixpopup").fadeOut();
        $('#deletemanualmixerror').css('display', 'none');
    });

    $('#btnDeleteMix').click(function () {
        $('#deletemanualmixpopup').modal('show');
        var id = $('#txtMixId').val();
        $('#hdnIdToDelete').val(id);
        $("#deletemanualmixpopup").fadeIn();
        $('#deletemanualmixerror').css('display', 'none');
    });

    $('#btnselectNextComponent').click(function () {
        $('#selectNextComponentpopup').modal('show');
        $("#selectNextComponentpopup").fadeIn();
    });

    $('#mixingItemsList').on('click', 'tbody tr.selectComponentForMix', function () {
        let expectedMix = 0;
        $('#mixingItemsList >tbody > tr.mix-updated').each(function (i, e) {
            expectedMix += parseInt($(this).find('td:eq(1) span.actual').text());
            $(this).find('td:eq(1) span.actual').show();
            $(this).find('td:eq(1) span.planned').hide();
        });
        expectedMix += parseInt($(this).find('td:eq(1) span.planned').text());
        $(this).find('td:last').html();
        $('#currentMixingFeed').text($(this).find('td:first').html());
        $('#hdnFeedActualWeight').text($(this).find('td:eq(1) span.planned').text());
        $('#feedActualWeight').text($(this).find('td:eq(1) span.planned').text() + " Kg");
        $('#currentMixingExpectedNumber').text(expectedMix);
        $('#txtActualNumber').val(expectedMix);
        $('#selectNextComponentpopup').modal('hide');
        $("#selectNextComponentpopup").fadeOut();
    });
    $('#chkAutoScale').change(function () {
        let scaleAccordingToFirstItem = false;
        if ($('#chkAutoScale').is(':checked')) {
            scaleAccordingToFirstItem = true;
            $('#btncalculatethefinalrecipe').show();
        }
        $.ajax({
            type: 'GET',
            url: '/api/maiturimix/autoscale?scaleAccordingToFirstItem=' + scaleAccordingToFirstItem,
            dataType: 'json',
            contentType: 'application/json',
            success: function (response) {
            }
        });
    });

    $('#btnapettaperanimalhint').click(function () {
        $('#apettaperanimalhintpopup').modal('show');
        $("#apettaperanimalhintpopup").fadeIn();
    });

    $('#btnnumberofanimalshint').click(function () {
        $('#numberofanimalshintpopup').modal('show');
        $("#numberofanimalshintpopup").fadeIn();
    });

    $('#btncalculatethefinalrecipe').click(function () {
        $('#calculatethefinalrecipepopup').modal('show');
        $("#calculatethefinalrecipepopup").fadeIn();
    });

    $('#btnconfirmcalculatethefinalrecipe').click(function (e) {
        e.preventDefault();

        $.ajax({
            type: 'GET',
            url: '/api/maiturimix/scaleaccordingcomponents',
            dataType: 'json',
            contentType: 'application/json',
            success: function (data) {
                bindMixingTable(data);
                selectRowForMix();
            }
        });

        $('#btncalculatethefinalrecipe').attr('disabled', 'disabled');
        $('#calculatethefinalrecipepopup').modal('hide');
        $("#calculatethefinalrecipepopup").fadeOut();
    });

    $('#btncancelcalculatethefinalrecipe').click(function () {
        $('#calculatethefinalrecipepopup').modal('hide');
        $("#calculatethefinalrecipepopup").fadeOut();
    });

    $('#btncancelrecentfeed').click(function (e) {
        e.preventDefault();
        var currentDate = new Date().toISOString();
        $.ajax({
            type: 'GET',
            url: '/api/maiturimix/cancelrecentfeed?currentDate=' + encodeURIComponent(currentDate),
            dataType: 'json',
            contentType: 'application/json',
            success: function (data) {
                bindMixingTable(data);
                selectRowForMix();
            }
        });
    });

    $('#startAgainBtn').click(function () {
        $('#confirmStartAgainpopup').modal('show');
        $("#confirmStartAgainpopup").fadeIn();
    });

    $('#btnConfirmStartAgain').click(function () {
        $('#confirmStartAgainpopup').modal('hide');
        $("#confirmStartAgainpopup").fadeOut();
        $.ajax({
            type: 'POST',
            url: '/api/maiturimix/startmixingagain',
            dataType: 'json',
            contentType: 'application/json',
            success: function (response) {
                if (response.Status == 'OK') {
                    $('#feedList').hide();
                    $('#feedDetails').show();
                    $('#editFeed').hide();
                    $('#feedmixing').hide();
                    $('#mixedDetails').hide();
                }
            }
        });
    });

    $('#btnCancelStartAgain').click(function () {
        $('#confirmStartAgainpopup').modal('hide');
        $("#confirmStartAgainpopup").fadeOut();
    });
});